<template>
  <header class="header">
    <button v-if="$route.name !== 'Projects'" class="header__tile project-icon" @click="openShare">Setting share</button>
    <div class="header__center">
      <h1 class="header__project-name">{{title}}</h1>
      <div>
        <LangSwitcher />
      </div>
    </div>
    <button class="header__tile logout-icon" @click="logout">Log out</button>
  </header>
</template>

<script>
import LangSwitcher from "./UI/LangSwitcher";
import { mapState, mapMutations } from 'vuex';

import api from "../../api";

export default {
  components: {
    LangSwitcher
  },
  computed: {
    ...mapState(['selectedProject', 'selectedScene', 'unsavedScenes']),
    title () {
      if (this.selectedScene) {
        return this.selectedScene.name;
      }

      if (this.selectedProject) {
        return this.selectedProject.name;
      }

      return 'Projects';
    }
  },
  methods: {
    ...mapMutations(["openPopup"]),
    openShare() {
      this.openPopup("share");
    },
    logout: function() {
      if (this.unsavedScenes.length) {
        const isLogout = confirm("You have unsaved changes. Are you sure you want to log out?");

        if (isLogout) {
          api.auth
            .logout()
            .then(result => {
              if (result.success) {
                this.$router.push({ name: "Infographics" });
              }
            });
        }

      } else {
        api.auth
        .logout()
        .then(result => {
          if (result.success) {
            this.$router.push({ name: "Infographics" });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 96px;
  width: 100%;

  &__center {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 0 45px;
  }

  &__project-name {
    color: #00bfff;
    font-weight: normal;
    font-size: 36px;
  }

  &__tile {
    position: relative;
    width: 96px;
    height: 96px;
    background-color: #cacad0;
    user-select: none;
    border: 0;
    cursor: pointer;

    &.logout-icon {
      color: #fff;
    }

    &.project-icon {
      background-image: url("../../assets/editor/project-icon.svg");
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: 40%;
      text-indent: -9999px;
    }
  }
}
</style>
